export const useGetPersonKey = name => ['useGetPersonKey', name];
